var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { Item, ItemImageService } from './item-image.service';
import { ItemAddRowDirective } from './item-addrow.directive';
var ItemImageComponent = /** @class */ (function (_super) {
    __extends(ItemImageComponent, _super);
    function ItemImageComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.items = [];
        _this.readonly = false;
        _this.checkFlg = true;
        _this.dispFlg = [];
        _this.deleteItems = [];
        _this.seq = 1;
        return _this;
    }
    ItemImageComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
    };
    ItemImageComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0) {
            this.col = this.cols[0];
        }
        this.checkFlg = true;
    };
    ItemImageComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ItemImageComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        this.service.getDispFlg().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.dispFlg = rec;
            }
        });
        this.items = [];
        this.deleteItems = [];
        if (typeof data[this.col.key] !== 'undefined' && data[this.col.key] instanceof Array) {
            this.items = data[this.col.key];
        }
        if (this.checkFlg) {
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (typeof item.id !== 'undefined') {
                    item.$type = "put" /* Put */;
                }
            }
            this.checkFlg = false;
        }
        this.seq = 1;
        for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
            var item = _c[_b];
            item.seq = this.seq;
            this.seq++;
        }
        if (this.col.required && this.items.length === 0) {
            this.items.push(Object.assign(new Item(), { seq: this.seq }));
            this.seq++;
        }
        this.setCompRec();
    };
    ItemImageComponent.prototype.trackByItem = function (index, item) {
        return item.seq;
    };
    ItemImageComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    ItemImageComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ItemImageComponent.prototype.onSort = function (e1, e2, index) {
        if (e2 === 'up') {
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
        }
        else if (e2 === 'down') {
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
        }
        this.setCompRec();
    };
    ItemImageComponent.prototype.onAdd = function () {
        this.items.push(Object.assign(new Item(), { seq: this.seq }));
        this.seq++;
        this.addError();
        this.setCompRec();
    };
    ItemImageComponent.prototype.onDelete = function (index) {
        if (typeof this.items[index].id !== 'undefined' && this.items[index].id !== null) {
            this.items[index].$type = "delete" /* Delete */;
            this.deleteItems.push(this.items[index]);
        }
        this.items.splice(index, 1);
        this.addError();
        this.setCompRec();
    };
    ItemImageComponent.prototype.onChange = function (e, key, index) {
        this.items[index][key] = e.val;
        this.setCompRec();
    };
    ItemImageComponent.prototype.setOrder = function () {
        var order = 1;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            item.disp_order = order;
            order++;
        }
    };
    ItemImageComponent.prototype.setCompRec = function () {
        this.setOrder();
        var items = {};
        items[this.col.key] = this.items.concat(this.deleteItems);
        this.action.setCompRec(this.componentName, items);
    };
    ItemImageComponent.prototype.addError = function () {
        if (this.col.required) {
            var errFlg = (this.items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
        }
    };
    ItemImageComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    ItemImageComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-image',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"col\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"col\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" itemAddRowDir>\n          <ul>\n            <li class=\"form_li\"></li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly\" scope=\"col\"></th>\n        <th [hidden]=\"readonly\" scope=\"col\"></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemImageComponent.label.image'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemImageComponent.label.alt'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemImageComponent.label.dispFlg'] }}</a></th>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"items\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly\" class=\"tableWrapper_arrowTd\">\n            <ul class=\"stageFlow_arrows\">\n              <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onSort($event, 'up', index)\"></a></li>\n              <li><a *ngIf=\"index < items.length - 1\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onSort($event, 'down', index)\"></a></li>\n            </ul>\n          </td>\n          <td [hidden]=\"readonly\" class=\"tableWrapper_iconTd\">\n            <a href=\"javascript:void(0);\" (click)=\"onDelete(index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li form_li-w400\">\n                    <column-file [key]=\"'list'\" [col]=\"{\n                    key: componentName + '.image-' + item['seq'],\n                    controlType: 'file',\n                    required: true,\n                    readonly: readonly,\n                    params: {uploadType: col?.params?.uploadType, formClass: {width: '400'}}\n                  }\" [val]=\"item['image']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'image', index)\"></column-file>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-text *ngIf=\"!readonly\" [key]=\"'list'\" [col]=\"{\n                    key: componentName + '.alt-' + item['seq'],\n                    controlType: 'text'\n                  }\" [val]=\"item['alt']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'alt', index)\"></column-text>\n                    <column-formreadonly *ngIf=\"readonly\" [col]=\"{controlType: 'text'}\" [val]=\"item['alt']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-radio *ngIf=\"!readonly\" [key]=\"'list'\" [col]=\"{\n                    key: componentName + '.disp_flg-' + item['seq'],\n                    controlType: 'radio',\n                    required: true,\n                    params: {options: dispFlg}\n                  }\" [val]=\"item['disp_flg']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'disp_flg', index)\"></column-radio>\n                    <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n                    controlType: 'radio',\n                    params: {options: dispFlg}\n                  }\" [val]=\"item['disp_flg']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"!readonly\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onAdd()\"></button>\n      </p>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    ItemImageComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemImageService }
    ]; };
    ItemImageComponent.propDecorators = {
        dir: [{ type: ViewChild, args: [ItemAddRowDirective,] }]
    };
    return ItemImageComponent;
}(ContentBaseComponent));
export { ItemImageComponent };
//# sourceMappingURL=item-image.component.js.map